import type { QueryClient } from '@tanstack/react-query';
import type { useAuthStore } from '@indipia/shared';
import type { LoginTokens } from '../api/auth';

type SetAuthFn = ReturnType<typeof useAuthStore.getState>['setAuth'];

/**
 * 로그인 토큰을 세션에 반영 — SnsLoginPage·가입 화면 자동로그인·SNS 로그인 등
 * 여러 진입점에서 공용으로 써야 해서 훅 밖에서 호출 가능한 함수로 분리.
 */
export function applyLoginTokens(
  tokens: LoginTokens,
  setAuth: SetAuthFn,
  queryClient: QueryClient,
): void {
  const masterYn = tokens.roles.some((r) => r === 'OWNER' || r === 'MASTER' || r === 'SUPER') ? 'Y' : 'N';
  queryClient.clear(); // 이전 유저 studioStage 등 캐시 제거 후 새 유저 데이터로 재조회
  setAuth({
    accessToken: tokens.accessToken,
    refreshToken: tokens.refreshToken,
    user: {
      memberId: tokens.userId,
      memberName: tokens.userName ?? '',
      compId: tokens.compId ?? 0,
      compName: '',
      masterYn,
    },
  });
}
